import { useAgTechQuery } from "@agtech/core/data/queries/AgTechDataQueries";
import DocumentHeaderConfigurationForm from "../forms/DocumentHeaderConfigurationForm"
import { SaleOperationDataGetDocumentHeaderConfigurationQuery } from "@sales/data/operation/SaleDataOperationQueries";
import AgTechQueryLoadingSurface from "@agtech/core/data/queries/AgTechQueryLoadingSurface";

const DocumentHeaderConfigurationPage = () => {
    let docQuery = useAgTechQuery({
            query: SaleOperationDataGetDocumentHeaderConfigurationQuery
        });

    return (
        <AgTechQueryLoadingSurface query={docQuery}>
            {(docHeader) => (
                <div className='stretched row-based container'>
                    <DocumentHeaderConfigurationForm config={docHeader}/>
                </div>
            )}
        </AgTechQueryLoadingSurface>
    )
}

export default DocumentHeaderConfigurationPage